import { useMutation, useQueryClient } from '@tanstack/react-query';
import { countriesApi } from '../api/countries.api';
import { COUNTRY_HIERARCHY_INPUT_KEY, COUNTRY_HIERARCHY_MULTI_SELECT_KEY, countryKeys } from './queryKeys';
import { regionKeys } from '@/features/regions/hooks/queryKeys';

export const useDeleteCountry = () => {
  const queryClient = useQueryClient();

  const deleteCountry = useMutation({
    mutationFn: (id: string) => countriesApi.deleteCountry(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: countryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: countryKeys.hierarchy() });
      queryClient.invalidateQueries({ queryKey: [COUNTRY_HIERARCHY_INPUT_KEY] });
      queryClient.invalidateQueries({ queryKey: [COUNTRY_HIERARCHY_MULTI_SELECT_KEY] });
      queryClient.invalidateQueries({ queryKey: regionKeys.lists(), refetchType: 'all' });
    },
  });

  return {
    deleteCountry: deleteCountry.mutate,
    isDeleting: deleteCountry.isPending,
  };
};
